import {
  getNotificationAnnouncementBadge,
  NOTIFICATION_PREFIX,
} from 'src/clients';
import useSWR from 'swr';

export const useNotificationAnnouncementData = () => {
  const {
    data,
    error: errorSwr,
    ...swr
  } = useSWR(
    `${NOTIFICATION_PREFIX}/badge-preview`,
    () => getNotificationAnnouncementBadge(),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
    },
  );

  const notificationUnread = data?.data?.data.notification_unread ?? 0;
  const whatsNewUnread = data?.data?.data?.whats_new_unread ?? 0;
  const notificationPreview = data?.data?.data?.notification_preview ?? [];
  const whatsNewPreview = data?.data?.data?.whats_new_preview ?? [];
  const bankMaintenanceUnread = data?.data?.data?.bank_maintenance_unread ?? 0;
  const error = errorSwr ? true : false;

  return {
    notificationUnread,
    whatsNewUnread,
    bankMaintenanceUnread,
    notificationPreview,
    whatsNewPreview,
    error,
    ...swr,
  };
};
